import { InjectionToken, Provider } from '@angular/core';

export type Constants = 'UNIT_USING_KEY' | 'PRIVACY_TERM_CONTENT_CONTENFUL_QUERY_KEY';

export const CONSTANTS = new InjectionToken<Record<Constants, unknown>>('CONSTANTS');

export const provideConstants = (): Provider => {
  return {
    provide: CONSTANTS,
    useValue: {
      UNIT_USING_KEY: 'unit-using',
      PRIVACY_TERM_CONTENT_CONTENFUL_QUERY_KEY: 'goodchartDocumentPageCollection',
    },
  };
};
